import { Controller } from "@hotwired/stimulus"

// Shows a large floating preview of a thumbnail on hover, pinned to the viewport
// (position: fixed) so it isn't clipped by the table's overflow, and following
// the cursor. One shared popup element is reused across all thumbnails.
export default class extends Controller {
  static values = { src: String }

  connect() {
    this.show = this.show.bind(this)
    this.move = this.move.bind(this)
    this.hide = this.hide.bind(this)
    this.element.addEventListener("mouseenter", this.show)
    this.element.addEventListener("mousemove", this.move)
    this.element.addEventListener("mouseleave", this.hide)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.show)
    this.element.removeEventListener("mousemove", this.move)
    this.element.removeEventListener("mouseleave", this.hide)
    this.hide()
  }

  show(event) {
    const popup = this.constructor.popup()
    popup.firstChild.src = this.srcValue
    popup.style.display = "block"
    this.move(event)
  }

  move(event) {
    const popup = this.constructor.popup()
    if (popup.style.display !== "block") return
    const pad = 18
    const w = popup.offsetWidth || 320
    const h = popup.offsetHeight || 320
    let x = event.clientX + pad
    let y = event.clientY + pad
    if (x + w > window.innerWidth) x = event.clientX - w - pad
    if (y + h > window.innerHeight) y = window.innerHeight - h - pad
    popup.style.left = `${Math.max(pad, x)}px`
    popup.style.top = `${Math.max(pad, y)}px`
  }

  hide() {
    const popup = this.constructor.existingPopup()
    if (popup) popup.style.display = "none"
  }

  static existingPopup() {
    return document.getElementById("ms-gen-hoverpop")
  }

  static popup() {
    let popup = this.existingPopup()
    if (!popup) {
      popup = document.createElement("div")
      popup.id = "ms-gen-hoverpop"
      popup.className = "ms-gen-hoverpop"
      popup.appendChild(document.createElement("img"))
      document.body.appendChild(popup)
    }
    return popup
  }
}
